"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocalBrandNameProperty = exports.localBrandNamePropertyDefinition = void 0;
exports.localBrandNamePropertyDefinition = {
    name: 'local-brand-name',
    type: 'text',
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'maxLength',
            argument: 18,
        },
    ],
    multiple: false,
    view: {
        label: 'Local brand name',
        style: 'h2',
    },
};
const isLocalBrandNameProperty = (prop) => {
    return prop.name === exports.localBrandNamePropertyDefinition.name;
};
exports.isLocalBrandNameProperty = isLocalBrandNameProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9jYWwtYnJhbmQtbmFtZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2xvY2FsLWJyYW5kLW5hbWUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxnQ0FBZ0MsR0FBRztJQUM5QyxJQUFJLEVBQUUsa0JBQWtCO0lBQ3hCLElBQUksRUFBRSxNQUFNO0lBQ1osV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsV0FBVztZQUNqQixRQUFRLEVBQUUsRUFBRTtTQUNiO0tBQ0Y7SUFDRCxRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxrQkFBa0I7UUFDekIsS0FBSyxFQUFFLElBQUk7S0FDWjtDQUM4QixDQUFBO0FBSTFCLE1BQU0sd0JBQXdCLEdBQUcsQ0FBQyxJQUFrQixFQUFrQyxFQUFFO0lBQzdGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx3Q0FBZ0MsQ0FBQyxJQUFJLENBQUE7QUFDNUQsQ0FBQyxDQUFBO0FBRlksUUFBQSx3QkFBd0IsNEJBRXBDIn0=